import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Checkbox } from 'antd';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import InputBlock from 'containers/InputBlock';
import MainHeading from 'containers/MainHeading';
import SelectOption from 'containers/SelectOption';

import { showNotification } from 'services/NotificationService';
import * as MasterApi from 'services/SubMasterApi';
import * as UserApi from 'services/UserApi';

import { isEmpty, isFunction } from 'util/utils';

import { USERS_TYPE } from 'constants/Common';
import OpenNotification from 'constants/OpenNotifications';

import { TabActions } from 'appRedux/reducers/TabIssueReducer/TabReducer';

import BottomStickyButton from './BottomStickButton';

class UserDrawer extends Component {
  state = {
    roleList: [],
    errors: {},
  };

  initialValues = {
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    mobile: '',
    type: undefined,
    isActive: true,
  };

  getInitialValues = () => {
    const { update } = this.props;
    return Object.fromEntries(
      Object.entries(this.initialValues).map(([key, value]) => [key, isEmpty(update?.[key]) ? value : update?.[key]]),
    );
  };

  componentDidMount() {
    this.masterList();
  }

  async masterList() {
    const [, res] = await MasterApi.getMastersList({
      filter: {
        parentCode: 'USER_ROLES',
        group: ['ADMIN', 'SELLER'],
        isActive: true,
      },
    });

    if (res && res.data && res.data.length) {
      this.setState({
        roleList: res.data,
      });
    }
  }

  /**
   * Function used to handel submit
   * @param {*} values
   * @param {*} param1
   */
  handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const { update } = this.props;

    const role =
      values.type === USERS_TYPE.ADMIN
        ? this.state.roleList.find((item) => item.group === 'ADMIN')
        : this.state.roleList.find((item) => item.group === 'SELLER');

    if (isEmpty(role?.id)) return OpenNotification({ type: 'error', title: 'Master not exist' });

    const data = {
      ...values,
      roles: [role.id],
    };
    setSubmitting(true);

    const [err, res] = await (!isEmpty(update?.id)
      ? UserApi.updateUserDetail(update.id, data)
      : UserApi.storeUserDetail(data));

    setSubmitting(false);

    if (!err && res && res.code === 'OK') {
      resetForm();
      this.closeDrawer();
    }

    if (!isEmpty(update)) this.userStoreUpdate(res?.data?.[0]);

    !err && showNotification(res);
  };

  userStoreUpdate = (user) => {
    let list = this.props?.userData?.data;
    list = list?.map((item) => {
      if (item?.id == user?.id) {
        item = user;
      }
      return item;
    });

    this.props.setUserList({ ...this.props.userData, data: list, userData: user });
  };

  closeDrawer = () => {
    isFunction(this.props.closeDrawer) && this.props.closeDrawer();
  };

  render() {
    return (
      <>
        <MainHeading className="mb-10" title={this.props?.update?.id ? 'Edit User' : 'Add User'} />

        <Formik
          initialValues={this.getInitialValues()}
          validateOnChange
          validationSchema={Yup.object().shape({
            firstName: Yup.string().trim().required('First name is required').typeError('First name must be a string'),
            lastName: Yup.string().required('Last name is required').typeError('Last name must be a string'),
            username: Yup.string().required('Username is required'),
            email: Yup.string().email('Invalid email').required('Email is required'),
            password: Yup.string()
              .when('id', {
                is: (val) => isEmpty(this.props.update),
                then: Yup.string().required('Password is required'),
              })
              .min(6, 'At least six character required'),
            mobile: Yup.string()
              .required('Mobile is required')
              .matches(/^[0-9]{7,15}$/, 'Mobile number length should between 7-15 and contains only number'),
            type: Yup.number()
              .oneOf([USERS_TYPE.ADMIN, USERS_TYPE.SELLER, USERS_TYPE.MASTER_SALES])
              .required('Please select type'),
          })}
          onSubmit={this.handleSubmit}
        >
          {({ handleChange, handleBlur, setFieldValue, setFieldTouched, touched, errors, values }) => (
            <Form>
              <div className="p-15">
                <div className="userListBlockWrapper">
                  <InputBlock
                    label="First Name *"
                    id="firstName"
                    name="firstName"
                    tabIndex="1"
                    placeholder="First Name"
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched?.firstName && errors?.firstName}
                  />
                  <InputBlock
                    label="Last Name *"
                    placeholder="Last Name"
                    id="lastName"
                    name="lastName"
                    tabIndex="2"
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched?.lastName && errors?.lastName}
                  />
                  <InputBlock
                    label="Username *"
                    placeholder="Username"
                    id="username"
                    name="username"
                    tabIndex="3"
                    value={values.username}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched?.username && errors?.username}
                  />
                  {isEmpty(this.props.update?.id) && (
                    <InputBlock
                      type="password"
                      label="Password *"
                      placeholder="Password"
                      id="password"
                      name="password"
                      tabIndex="4"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched?.password && errors?.password}
                    />
                  )}
                  <InputBlock
                    label="Mobile *"
                    placeholder="Mobile"
                    id="mobile"
                    name="mobile"
                    tabIndex="5"
                    onKeyPress={(evt) => {
                      if (evt.which != 8 && evt.which != 0 && (evt.which < 48 || evt.which > 57) && evt.which != 45) {
                        evt.preventDefault();
                      }
                    }}
                    value={values.mobile}
                    onChange={(event) => {
                      setFieldValue('mobile', event.target.value.replace(/\D/g, ''));
                    }}
                    onBlur={handleBlur}
                    error={touched?.mobile && errors?.mobile}
                  />
                  <InputBlock
                    label="Email *"
                    placeholder="Email"
                    id="email"
                    type="email"
                    name="email"
                    tabIndex="6"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched?.email && errors?.email}
                  />
                  <SelectOption
                    placeholder="Select Type"
                    label="Type"
                    tabIndex="7"
                    selectValue={Object.entries(USERS_TYPE)
                      .filter((item) => item[0] === 'ADMIN' || item[0] === 'SELLER' || item[0] === 'MASTER_SALES')
                      .map(([value, key]) => ({
                        key,
                        value: value === 'SELLER' ? 'SALES PERSON' : value === 'MASTER_SALES' ? 'MASTER SALES' : value,
                      }))}
                    value={
                      [USERS_TYPE.ADMIN, USERS_TYPE.SELLER, USERS_TYPE.MASTER_SALES].filter(
                        (item) => item == values.type,
                      )?.length
                        ? `${values.type}`
                        : undefined
                    }
                    onChange={(value) => setFieldValue('type', value)}
                    onBlur={() => setFieldTouched('type', true)}
                    error={touched?.type && errors?.type}
                  />

                  <div className="checkBoxForm">
                    <label style={{ marginTop: '20px' }}>Active</label>
                    <Checkbox
                      tabIndex="8"
                      checked={Boolean(values.isActive)}
                      onChange={() => setFieldValue('isActive', !values.isActive)}
                    />
                  </div>

                  {/* <SelectOption defaultValue="Select Country" selectValue={ManageParameters.country} label="Country"/> */}
                </div>
              </div>
              <BottomStickyButton>
                <button tabIndex="9" className="commonButton" type="submit">
                  Save
                </button>
                {this.props?.update?.id ? (
                  <button tabIndex="10" className="commonOutine" onClick={this.closeDrawer} type="button">
                    Cancel
                  </button>
                ) : (
                  <button tabIndex="10" className="commonOutine" onClick={this.closeDrawer} type="reset">
                    Cancel
                  </button>
                )}
              </BottomStickyButton>
            </Form>
          )}
        </Formik>
      </>
    );
  }
}

export default connect(
  ({ tab }) => ({
    userData: tab.userList,
  }),
  {
    setUserList: TabActions.setUserList,
  },
)(UserDrawer);
